// ABOUTME: Vormgeving tab for the relation return portal settings.
// ABOUTME: Shows a gallery of portal screens; each opens its style editor in a bottom sheet.
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import Subheading from "../../../../../components/theme/text/Subheading";
import SHModalBottom from "../../../../../components/theme/Modal/SHModalBottom";
import GenericReturnBuilderScreenWrapper from "./GenericReturnBuilderScreenWrapper";
import { page_keys } from "../../../../../components/portalbuilder/config";
import EditRegisterReturn from "../../../../../components/portalbuilder/views/EditRegisterReturn";
import EditOrderLinesToReturn from "../../../../../components/portalbuilder/views/EditOrderLinesToReturn";
import EditOrderLinesConfirm from "../../../../../components/portalbuilder/views/EditOrderLinesConfirm";
import EditReturnSubmitted from "../../../../../components/portalbuilder/views/EditReturnSubmitted";
import EditStatusPage from "../../../../../components/portalbuilder/views/EditStatusPage";
import { editOrderLinesConfirmMap, editOrderLinesMap, editRegisterReturnMap, editReturnStatusPageMap, editReturnSubmittedMap } from "../../../../../components/portalbuilder/Mastermaps";
import Text from "../../../../../components/theme/text/Text";

const screens = [
    { key: "home_screen", pageKey: page_keys.EDITREGISTERRETURN, Component: EditRegisterReturn, map: editRegisterReturnMap },
    { key: "order_lines_to_return", pageKey: page_keys.EDITORDERLINESRETURN, Component: EditOrderLinesToReturn, map: editOrderLinesMap },
    { key: "order_lines_confirm", pageKey: page_keys.EDITORDERLINESCONFIRM, Component: EditOrderLinesConfirm, map: editOrderLinesConfirmMap },
    { key: "return_submitted", pageKey: page_keys.EDITRETURNSUBMITTED, Component: EditReturnSubmitted, map: editReturnSubmittedMap },
    { key: "return_status", pageKey: page_keys.RETURNSTATUSPAGE, Component: EditStatusPage, map: editReturnStatusPageMap },
];

const Vormgeving = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selected, setSelected] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        props.replaceView({
            ...props.config,
        });

        return () => {};
    }, []);

    const handleOpen = (screen) => {
        setSelected(screen);
        setOpen(true);
    };

    // Only close the drawer; keep `selected` mounted so the content stays
    // visible while the bottom sheet animates out.
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ height: 1, overflow: "auto", p: 4 }}>
            <Box sx={{ mb: 3 }}>
                <Subheading>{t("vormgeving")}</Subheading>
            </Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                    gap: 3,
                }}
            >
                {screens.map((screen) => (
                    <ButtonBase
                        key={screen.key}
                        onClick={() => handleOpen(screen)}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                            textAlign: "left",
                            borderRadius: 4,
                            overflow: "hidden",
                            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                            boxShadow: `0 2px 4px ${colors.grey[200]}`,
                            transition: "transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease",
                            "&:hover": {
                                transform: "translateY(-4px)",
                            },
                        }}
                    >
                        <Box
                            sx={{
                                position: "relative",
                                height: 210,
                                overflow: "hidden",
                                background: colors.grey[200],
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: 1280,
                                    transform: "scale(0.28)",
                                    transformOrigin: "top left",
                                    pointerEvents: "none",
                                }}
                            >
                                <screen.Component
                                    map={props.transformedData[screen.pageKey]}
                                    relationMenuData={props.relationMenuData}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ p: 2 }}>
                            <Text>{t(screen.key)}</Text>
                        </Box>
                    </ButtonBase>
                ))}
            </Box>

            <SHModalBottom
                open={open}
                onClose={handleClose}
                maxWidth={1450}
            >
                <Box sx={{ height: 1, display: "flex", flexDirection: "column" }}>
                    {selected &&
                        <GenericReturnBuilderScreenWrapper
                            replaceView={() => {}}
                            saveDesign={props.saveDesign}
                            setTransformedData={props.setTransformedData}
                            fullMap={props.transformedData}
                            data={props.transformedData[selected.pageKey]}
                            config={{}}
                            PreviewComponent={selected.Component}
                            EditorComponent={selected.Component}
                            map={selected.map}
                            pageKey={selected.pageKey}
                            relationMenuData={props.relationMenuData}
                            styleUpdating={props.styleUpdating}
                        />
                    }
                </Box>
            </SHModalBottom>
        </Box>
    );
};

export default Vormgeving;
